export default __webpack_public_path__ + "static/404-not-found-4edc3b7891f06a4687bf3a96b3790efe.svg";